<template>
  <div class="container_box details_box_styles">
    <!--返回按钮-->
    <div class="go_back" @click="goBackBtn">
      <Icon class="back_icon" type="ios-arrow-back"/>
      <span class="back_txt">{{ $t('key1002627') }}</span>
    </div>
    <!--基本信息-->
    <div class="basic_information_box">
      <Card :bordered="false" dis-hover>
        <template #title>
          <h2 class="title_box">{{ $t('key1000929') }}</h2>
        </template>
        <Row type="flex" :gutter="gutterItem">
          <Col :span="ItemCol" class="basic_item" v-for="(item, index) in basicInfoList" :key="index">
            <span class="basic_title">{{ item.name }}</span>
            <span class="basic_txt">{{ detailsData[item.paramsKey] }}</span>
          </Col>
        </Row>
      </Card>
    </div>
    <!--账单明细-->
    <div class="basic_information_box">
      <Card :bordered="false" dis-hover>
        <template #title>
          <h2 class="title_box">{{ $t('key1003610') }}</h2>
        </template>
        <Form ref="pageParams" :model="pageParams" :label-width="labelWidth" @submit.native.prevent>
          <Row type="flex" :gutter="gutterItem">
            <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
              <dropDownFilter
                ref="dropDownFilter"
                inputType="text"
                :selectStyle="{width: '130px'}"
                :dropDownInputList="dropDownInputList"
                :defaultSelectValue="defaultSelectValue"
                @changeInput="changeInput"
                @updateInputValue="updateInputValue">
              </dropDownFilter>
            </Col>
            <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
              <Form-item :label="$t('key1003604')" prop="businessNo">
                <Input v-model.trim="pageParams.businessNo" :placeholder="$t('key1003605')" clearable></Input>
              </Form-item>
            </Col>
            <Col style="min-width: 200px;" push="1">
              <Button @click="reset" icon="md-refresh" class="mr10">{{ $t('key1000109') }}</Button>
              <Button type="primary" @click="search" icon="md-search">{{ $t('key1000361') }}</Button>
            </Col>
          </Row>
        </Form>
        <div class="table_box">
          <Table
            highlight-row
            border
            max-height="400"
            :loading="tableLoading"
            :columns="tableColumns"
            :data="tableData">
          </Table>
          <div class="flex align-items-center justify-content-between">
            <div class="flex align-items-center pl10">
              <p class="mr25">{{ $t('key1003606') + total + $t('key1003607') }}</p>
              <p class="mr25">{{ $t('key1003608') + totalPackageProfit + ' ' + (detailsData.currency || '') }}</p>
              <p>{{ $t('key1003609') + totalPackageCost + ' ' + (detailsData.currency || '') }}</p>
            </div>
            <Page
              :transfer="true"
              v-if="!tableLoading"
              :total="total"
              @on-change="changePage"
              show-total
              :page-size="pageParams.pageSize"
              show-elevator
              :current="pageParams.pageNum"
              show-sizer
              @on-page-size-change="changePageSize"
              placement="top"
              :page-size-opts="pageArray">
            </Page>
          </div>
        </div>
      </Card>
    </div>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import DropDownFilter from "@/components/common/dropDownFilter.vue";
import {commonLocalStorage, isValueEmpty} from "@/utils/common";

export default {
  name: 'platformBillDetails',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      pageParamsStatus: false,
      ItemCol: 6,
      detailsData: {},
      basicInfoList: [
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003593'), paramsKey: 'billTime'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003594'), paramsKey: 'updatedTime'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003595'), paramsKey: 'totalProfit'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003596'), paramsKey: 'totalPrice'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003597'), paramsKey: 'totalExpenditureCost'},
      ],
      pageParams: {
        businessNo: '',
        distributorMerchantId: '',
        supplierMerchantId: '',
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      tableColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003598'),
          key: 'businessNo',
          minWidth: 150,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000738'),
          key: 'currency',
          minWidth: 150,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002877'),
          key: 'distributorMerchantId',
          minWidth: 150,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003599'),
          key: 'orderAmount',
          minWidth: 150,
          align: 'center',
          render(h, params) {
            let price = v.formatCurrency(params.row.amount);
            return h('span', price);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001098'),
          key: 'supplierMerchantId',
          minWidth: 150,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003600'),
          key: 'goodsCostSupplierSettlementAmount',
          minWidth: 230,
          align: 'center',
          render(h, params) {
            let price = v.formatCurrency(params.row.otherCost);
            return h('span', price);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003601'),
          key: 'orderProfit',
          minWidth: 150,
          align: 'center',
          render(h, params) {
            let price = v.formatCurrency(params.row.packageProfit);
            return h('span', price);
          }
        }
      ],
      tableData: [],
      dropDownInputList: [
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002877'), value: 1, placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003602'), parameterKey: 'distributorMerchantId'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001098'), value: 2, placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003603'), parameterKey: 'supplierMerchantId'}
      ],
      defaultSelectValue: 1,
      totalPackageCost: 0,
      totalPackageProfit: 0
    }
  },
  computed: {},
  created() {
    this.initPlatformBillDetails(this.$route.query.ymsBillId);
    this.search();
  },
  methods: {
    // 返回列表
    goBackBtn() {
      this.$router.push('/platformBill');
    },
    // 获取平台账单详情
    initPlatformBillDetails(ymsBillId) {
      this.axios.get(api.get_ymsBill_coreBill + ymsBillId).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data) {
            let costKeyList = ['totalExpenditureCost', 'totalPrice', 'totalProfit'];
            costKeyList.map((key) => {
              data[key] = this.formatCurrency(data[key]) + ' ' + data.currency;
            });
            // 账单周期
            let periodStartTime = data.periodStartTime;
            let periodEndTime = data.periodEndTime;
            data.billTime = this.$uDate.getDateTime(periodStartTime) + ' ~ ' + this.$uDate.getDateTime(periodEndTime);
            data.updatedTime = this.$uDate.dealTime(data.updatedTime) || '-';
            this.detailsData = data;
          }
        }
      });
    },
    // 获取账单明细
    getList() {
      let query = {
        ...this.pageParams,
        ymsBillId: this.$route.query.ymsBillId
      }
      this.tableData = [];
      this.total = 0;
      this.axios.post(api.post_ymsBill_queryCoreBillDetail, query).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data) {
            this.getStatistics(query);
            this.tableData = data.list || [];
            this.total = data.total || 0;
            this.$nextTick(() => {
              this.tableLoading = false;
            });
          }
        } else {
          this.tableLoading = false;
        }
      });
    },
    // 获取统计数据
    getStatistics(query) {
      this.totalPackageCost = 0;
      this.totalPackageProfit = 0;
      this.axios.post(api.post_ymsBill_queryCoreBillDetailTotal, query).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data) {
            this.totalPackageCost = data.totalPackageCost || 0;
            this.totalPackageProfit = data.totalPackageProfit || 0;
          }
        }
      });
    },
    // 查询按钮
    search() {
      this.pageParams.pageNum = 1;
      this.pageParamsStatus = true;
    },
    // 重置按钮
    reset() {
      this.$refs['pageParams'].resetFields();
      this.changeInput(1);
    },
    // 获取下拉选项筛选条件的值
    updateInputValue(data) {
      this.pageParams[data.key] = data.value;
    },
    // 改变默认下拉选项的值
    changeInput(value) {
      this.defaultSelectValue = value;
      this.$refs.dropDownFilter.inputValue = '';
      this.dropDownInputList.map((item) => {
        if (Object.keys(this.pageParams).includes(item.parameterKey)) {
          this.pageParams[item.parameterKey] = '';
        }
      });
    },
  },
  watch: {
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        v.getList();
        v.pageParamsStatus = false;
      }
    }
  },
  components: {
    DropDownFilter
  }
};
</script>

<style lang="less">

</style>
